export default __webpack_public_path__ + "static/media/afeez.e0b050c8.png";